import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
}

export const PageTransition = ({ children }: Props) => {
  const location = useLocation();

  return (
    <AnimatePresence initial={false} mode="popLayout">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0.5, y: 0 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 0 }}
        transition={{ 
          duration: 0.15,
          ease: "easeInOut"
        }}
        className="min-h-full"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};